import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { ContainerStyle } from './LoadingIndicator.styled';

export default function LoadingIndicator() {

  return (
    <ContainerStyle>
        <div className='logo' >
          <h2>آواشو</h2>
        </div>
        <span>
           ... در حال بارگذاری
        </span>
    </ContainerStyle>
  )
}
